import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import User from "@/models/User.js";
import "firebase/auth";
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior() {
		return {x: 0, y: 0};
	},
	routes: [
		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: "",
			component: () => import("@/layouts/main/Main.vue"),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================
				{
					path: "/",
					redirect: "/pages/login",
				},
				//COMPANY
				{
					path: "/dashboard/company",
					name: "company",
					component: () => import("@/components/Company/Company.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{
								title: "Home",
								i18n: "",
								url: "/dashboard/company",
							},
							{
								title: "CompanyModule.ManagingCompanies",
								i18n: "CompanyModule.ManagingCompanies",
								active: true,
							},
						],
						pageTitle: "Company",
						i18n: "Company",
						rule: "admin",
						permission_id: 6,
						permission_name: "COMPANY",
					},
				},
				{
					path: "/dashboard/company/list",
					name: "companyListView",
					component: () => import("@/components/Company/CompanyListView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/company"},
							{title: "Data List"},
							{title: "List", active: true},
						],
						pageTitle: "Company",
						rule: "admin",
						permission_id: 6,
						permission_name: "COMPANY",
					},
				},
				{
					path: "/dashboard/resource-company",
					name: "resource-company",
					component: () => import("@/components/Company/FirstResourceForm.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{
								title: "Home",
								i18n: "",
								url: "/dashboard/company",
							},
							{title: "Recurso", i18n: "CreateResource"},
							{
								title: "Administrador",
								i18n: "CreateResource",
								active: true,
							},
						],
						pageTitle: "CreateResource",
						i18n: "CreateResource",
						rule: "admin",
						permission_id: 6,
						permission_name: "COMPANY",
					},
					props: true,
				},
				//ROLE
				{
					path: "/dashboard/role",
					name: "role",
					component: () => import("@/views/role/Role.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", i18n: "", url: "/dashboard/role"},
							{title: "List Role", i18n: "MODULE_ROLE.RoleList", active: true},
						],
						pageTitle: "MODULE_ROLE.Roles",
						i18n: "Roles",
						rule: "editor",
						permission_id: 3,
						permission_name: "ROLE",
					},
				},
				{
					path: "/dashboard/update-role",
					name: "UpdateRole",
					component: () => import("@/views/role/UpdateRole.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", i18n: "", url: "/dashboard/role"},
							{title: "List Role", i18n: "MODULE_ROLE.Roles", url: "/dashboard/role"},
							{title: "List", i18n: "MODULE_ROLE.TitleUpdate", active: true},
						],
						pageTitle: "MODULE_ROLE.TitleUpdate",
						i18n: "Role",
						rule: "editor",
						permission_id: 3,
						permission_name: "ROLE",
					},
				},
				{
					path: "/dashboard/create-role",
					name: "CreateRole",
					component: () => import("@/views/role/CreateRole.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", i18n: "", url: "/dashboard/role"},
							{title: "List Role", i18n: "MODULE_ROLE.Roles", url: "/dashboard/role"},
							{title: "List", i18n: "MODULE_ROLE.TitleCrear", active: true},
						],
						pageTitle: "MODULE_ROLE.TitleCrear",
						i18n: "Role",
						rule: "editor",
						permission_id: 3,
						permission_name: "ROLE",
					},
				},
				{
					path: "/dashboard/permission",
					name: "permission",
					component: () => import("@/components/permissions/permissions.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{
								title: "Home",
								i18n: "",
								url: "/dashboard/permission",
							},
							{title: "List", i18n: "MODULE_PERMISSION.ListOfPermissions", active: true},
						],
						pageTitle: "MODULE_PERMISSION.Permissions",
						i18n: "Permission",
						rule: "admin",
						permission_id: 1,
						permission_name: "PERMISSION",
					},
				},
				// Breaks Module
				{
					path: "/dashboard/breaks/list",
					name: "BreaksListView",
					component: () => import("@/components/break/list/BreakList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/breaks/list"},
							{
								title: "ListOfBreaks",
								i18n: "ListOfBreaks",
								url: "/dashboard/breaks/list",
								active: true,
							},
						],
						pageTitle: "Breaks",
						rule: "editor",
						permission_id: 7,
						permission_name: "BREAKS",
					},
				},
				{
					path: "/dashboard/new-break",
					name: "NewBreak",
					component: () => import("@/components/break/create/BreakCreate.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/breaks/list"},
							{
								title: "Breaks",
								i18n: "Breaks",
								url: "/dashboard/breaks/list",
							},
							{
								title: "CreateBreak",
								i18n: "CreateBreak",
								active: true,
							},
						],
						pageTitle: "CreateBreak",
						rule: "editor",
						permission_id: 7,
						permission_name: "BREAKS",
					},
				},
				{
					path: "/dashboard/update-break/:id?",
					name: "UpdateBreak",
					component: () => import("@/components/break/edit/BreakEdit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/breaks/list"},
							{
								title: "Breaks",
								i18n: "Breaks",
								url: "/dashboard/breaks/list",
							},
							{
								title: "UpdateBreak",
								i18n: "UpdateBreak",
								active: true,
							},
						],
						pageTitle: "UpdateBreak",
						rule: "editor",
						permission_id: 7,
						permission_name: "BREAKS",
					},
				},
				{
					path: "/dashboard/breaks/break-view/:id",
					name: "app-break-view",
					component: () => import("@/components/break/BreakView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/breaks/list"},
							{
								title: "Breaks",
								i18n: "Breaks",
								url: "/dashboard/breaks/list",
							},
							{
								title: "visualizeBreak",
								i18n: "visualizeBreak",
								active: true,
							},
						],
						pageTitle: "visualizeBreak",
						rule: "editor",
						permission_id: 5,
						permission_name: "BREAKS",
					},
				},
				// Skills Module
				{
					path: "/dashboard/skills/list",
					name: "SkillsListView",
					component: () => import("@/components/skills/SkillList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/skills/list"},
							{
								title: "Skills.ListOfSkills",
								i18n: "Skills.ListOfSkills",
								active: true,
							},
						],
						pageTitle: "Skills.Skills",
						rule: "editor",
						permission_id: 8,
						permission_name: "SKILLS",
					},
				},
				{
					path: "/dashboard/new-skill",
					name: "NewSkill",
					component: () => import("@/components/skills/CreateSkill.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/skills/list"},
							{title: "Skills.Skills", i18n: "Skills.Skills", url: "/dashboard/skills/list"},
							{title: "Skills.CreateSkill", i18n: "Skills.CreateSkill", active: true},
						],
						pageTitle: "Skills.CreateSkill",
						rule: "editor",
						permission_id: 8,
						permission_name: "SKILLS",
					},
				},
				{
					path: "/dashboard/update-skill/:id?",
					name: "UpdateSkill",
					component: () => import("@/components/skills/UpdateSkill.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/skills/list"},
							{title: "Skills.Skills", i18n: "Skills.Skills", url: "/dashboard/skills/list"},
							{title: "Skills.UpdateSkill", i18n: "Skills.UpdateSkill", active: true},
						],
						pageTitle: "Skills.UpdateSkill",
						rule: "editor",
						permission_id: 8,
						permission_name: "SKILLS",
					},
				},
				// Capacity Module
				{
					path: "/dashboard/capacity/capacity-list",
					name: "CapacityList",
					component: () => import("@/components/capacity/CapacityList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/capacity/capacity-list"},
							{title: "Capacity.CapabilityList", i18n: "Capacity.CapabilityList", active: true},
						],
						pageTitle: "Capacity.Capabilities",
						rule: "editor",
						permission_id: 8,
						permission_name: "CAPABILITIES",
					},
				},
				{
					path: "/dashboard/create-capacity",
					name: "CreateCapacity",
					component: () => import("@/components/capacity/CreateCapacity.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/capacity/capacity-list"},
							{
								title: "Capacity.Capabilities",
								i18n: "Capacity.Capabilities",
								url: "/dashboard/capacity/capacity-list",
							},
							{title: "Capacity.CreateCapacity", i18n: "Capacity.CreateCapacity", active: true},
						],
						pageTitle: "Capacity.CreateCapacity",
						rule: "editor",
						permission_id: 8,
						permission_name: "CAPABILITIES",
					},
				},
				{
					path: "/dashboard/update-capacity/:id?",
					name: "UpdateCapacity",
					component: () => import("@/components/capacity/UpdateCapacity.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/capacity/capacity-list"},
							{
								title: "Capacity.Capabilities",
								i18n: "Capacity.Capabilities",
								url: "/dashboard/capacity/capacity-list",
							},
							{title: "Capacity.UpdateCapacity", i18n: "Capacity.UpdateCapacity", active: true},
						],
						pageTitle: "Capacity.UpdateCapacity",
						rule: "editor",
						permission_id: 8,
						permission_name: "CAPABILITIES",
					},
				},
				// Teams Module
				{
					path: "/dashboard/teams/list",
					name: "TeamsListView",
					component: () => import("@/components/teams/TeamsListView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/teams/list"},
							{
								title: "Teams.ListOfTeams",
								i18n: "Teams.ListOfTeams",
								url: "/dashboard/teams/list",
								active: true,
							},
						],
						pageTitle: "Teams.Teams",
						rule: "editor",
						permission_id: 9,
						permission_name: "TEAMS",
					},
				},
				{
					path: "/dashboard/new-team",
					name: "NewTeam",
					component: () => import("@/components/teams/CreateTeam.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/teams/list"},
							{
								title: "Teams.Teams",
								i18n: "Teams.Teams",
								url: "/dashboard/teams/list",
							},
							{
								title: "Teams.CreateTeam",
								i18n: "Teams.CreateTeam",
								active: true,
							},
						],
						pageTitle: "Teams.CreateTeam",
						rule: "editor",
						permission_id: 9,
						permission_name: "TEAMS",
					},
				},
				{
					path: "/dashboard/update-team/:id?",
					name: "UpdateTeam",
					component: () => import("@/components/teams/UpdateTeam.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/teams/list"},
							{
								title: "Teams.Teams",
								i18n: "Teams.Teams",
								url: "/dashboard/teams/list",
							},
							{
								title: "Teams.UpdateTeam",
								i18n: "Teams.UpdateTeam",
								active: true,
							},
						],
						pageTitle: "Teams.UpdateTeam",
						rule: "editor",
						permission_id: 9,
						permission_name: "TEAMS",
					},
					props: true,
				},
				// Depot Module
				{
					path: "/dashboard/deposits/list",
					name: "DepositListView",
					component: () => import("@/components/depot/DepotListView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/deposits/list"},
							{
								title: "Deposits.ListOfDeposits",
								i18n: "Deposits.ListOfDeposits",
								url: "/dashboard/deposits/list",
								active: true,
							},
						],
						pageTitle: "Deposits.Depot",
						rule: "editor",
						permission_id: 10,
						permission_name: "DEPOSITS",
					},
				},
				{
					path: "/dashboard/new-deposit",
					name: "NewDeposit",
					component: () => import("@/components/depot/CreateDepot.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/deposits/list"},
							{
								title: "Deposits.Depot",
								i18n: "Deposits.Depot",
								url: "/dashboard/deposits/list",
							},
							{
								title: "Deposits.CreateDeposit",
								i18n: "Deposits.CreateDeposit",
								active: true,
							},
						],
						pageTitle: "Deposits.CreateDeposit",
						rule: "editor",
						permission_id: 10,
						permission_name: "DEPOSITS",
					},
				},
				{
					path: "/dashboard/update-deposit/:id?",
					name: "UpdateDeposit",
					component: () => import("@/components/depot/UpdateDeposit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/deposits/list"},
							{
								title: "Deposits.Depot",
								i18n: "Deposits.Depot",
								url: "/dashboard/deposits/list",
							},
							{
								title: "Deposits.UpdateDeposit",
								i18n: "Deposits.UpdateDeposit",
								active: true,
							},
						],
						pageTitle: "Deposits.UpdateDeposit",
						rule: "editor",
						permission_id: 10,
						permission_name: "DEPOSITS",
					},
					props: true,
				},
				{
					path: "/dashboard/indicator",
					name: "app-indicator-create",
					component: () => import("@/components/indicator/Indicator.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/indicator"},
							{
								title: "Indicators.Indicators",
								i18n: "Indicators.Indicators",
								url: "/dashboard/indicator",
								active: true,
							},
						],
						pageTitle: "Indicators.Indicators",
						rule: "editor",
						permission_id: 10,
						permission_name: "INDICATORS",
					},
				},
				// Optimization Module
				{
					path: "/dashboard/optimization",
					name: "app-optimization",
					component: () => import("@/components/optimization/Optimization.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/home"},
							{
								title: "Optimization.CreateOptimization",
								i18n: "Optimization.CreateOptimization",
								active: true,
							},
						],
						pageTitle: "Optimization.Optimizations",
						rule: "editor",
						permission_id: 10,
						permission_name: "OPTIMIZATIONS",
					},
				},
				{
					path: "/dashboard/optimization/list",
					name: "OptimizationList",
					component: () => import("@/components/optimization/OptimizationList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/home"},
							{
								title: "Optimization.ListOfOptimizations",
								i18n: "Optimization.ListOfOptimizations",
								active: true,
							},
						],
						pageTitle: "Optimization.Optimizations",
						rule: "editor",
						permission_id: 10,
						permission_name: "OPTIMIZATIONS",
					},
				},
				{
					path: "/dashboard/reoptimization/:id?",
					name: "app-reoptimization",
					component: () => import("@/components/optimization/edit/ReOptimizationEdit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/home"},
							{
								title: "Optimization.Optimizations",
								i18n: "Optimization.Optimizations",
							},
							{
								title: "Optimization.ListOfOptimizations",
								i18n: "Optimization.ListOfOptimizations",
								url: "/dashboard/optimization/list",
							},
							{
								title: "Routing.Buttons.ReOptimizeRoutes",
								i18n: "Routing.Buttons.ReOptimizeRoutes",
								active: true,
							},
						],
						pageTitle: "Routing.Buttons.ReOptimizeRoutes",
						rule: "editor",
						permission_id: 10,
						permission_name: "OPTIMIZATIONS",
					},
				},
				{
					path: "/dashboard/optimization-map/:id?",
					name: "optimization-map",
					component: () => import("@/components/optimization/Map.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 5,
						permission_name: "OPTIMIZATIONS",
					},
					props: true,
				},
				// Status Module
				{
					path: "/dashboard/status/list",
					name: "StatusListView",
					component: () => import("@/views/status/StatusListView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/status/list"},
							{
								title: "Status List",
								i18n: "Status.ListOfStatus",
								active: true,
							},
						],
						pageTitle: "Status.Title",
						rule: "admin",
						permission_id: 11,
						permission_name: "STATUS",
					},
				},
				// Type Config Module
				{
					path: "/dashboard/typeconfig/list",
					name: "TypeConfigListView",
					component: () => import("@/components/typeConfig/TypeConfigCrud.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{
								title: "Home",
								url: "/dashboard/typeconfig/list",
							},
							{
								title: "Type Config List",
								i18n: "TypeConfig.Title",
								active: true,
							},
						],
						pageTitle: "TypeConfig.Title",
						rule: "admin",
						permission_id: 12,
						permission_name: "TYPE CONFIG",
					},
				},
				{
					path: "/dashboard/setting/:company_id?",
					name: "app-setting",
					component: () => import("@/components/setting/appSettings.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/setting"},
							{
								title: "Type Config List",
								i18n: "CompanyConfigCrud",
								active: true,
							},
						],
						pageTitle: "Setting.Setting",
						i18n: "Setting.Setting",
						rule: "editor",
						permission_id: 24,
						permission_name: "STATUS",
						module_name: "STATUS",
					},
				},
				{
					path: "/dashboard/session-api/:id?",
					name: "session-api",
					component: () => import("@/components/session-api/SessionApi.vue"),
					meta: {
						breadcrumb: [
							{title: "Home", url: "/dashboard/session-api"},
							{
								title: "SessionApi.AccessToken",
								i18n: "SessionApi.AccessToken",
								active: true,
							},
						],
						authRequired: true,
						pageTitle: "SessionApi.SessionApi",
						i18n: "SessionApi.SessionApi",
						rule: "editor",
						permission_id: 12,
						permission_name: "TYPE CONFIG",
					},
				},
				// =============================================================================
				// Application Routes
				// =============================================================================
				{
					path: "/dashboard/home",
					name: "dashboard-home",
					component: () => import("@/views/InformativeDashboard.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 5,
						permission_name: "ROUTER",
					},
				},
				//VISIT POINT
				{
					path: "/apps/visit-point/create/:id?",
					name: "app-visit-point-create",
					component: () => import("@/components/visit-point/create/VisitPointCreate.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/visit-point/visit-point-list"},
							{
								title: "RouterSelection.VisitPoints",
								i18n: "RouterSelection.VisitPoints",
								url: "/apps/visit-point/visit-point-list",
							},
							{
								title: "VisitPoints.CreateVisitPoint",
								i18n: "VisitPoints.CreateVisitPoint",
								active: true,
							},
						],
						pageTitle: "VisitPoints.CreateVisitPoint",
						rule: "editor",
						permission_id: 5,
						permission_name: "VISIT_POINT",
					},
				},
				{
					path: "/apps/visit-point/visit-point-edit/:id",
					name: "app-visit-point-edit",
					component: () => import("@/components/visit-point/edit/VisitPointEdit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/visit-point/visit-point-list"},
							{
								title: "RouterSelection.VisitPoints",
								i18n: "RouterSelection.VisitPoints",
								url: "/apps/visit-point/visit-point-list",
							},
							{
								title: "VisitPoints.UpdatePointofVisit",
								i18n: "VisitPoints.UpdatePointofVisit",
								active: true,
							},
						],
						pageTitle: "VisitPoints.UpdatePointofVisit",
						rule: "editor",
						permission_id: 5,
						permission_name: "VISIT_POINT",
					},
				},
				{
					path: "/apps/visit-point/visit-point-list",
					name: "app-visit-point-list",
					component: () => import("@/components/visit-point/list/VisitPointList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/visit-point/visit-point-list"},
							{
								title: "Routing.Title.VisitPointsList",
								i18n: "Routing.Title.VisitPointsList",
								active: true,
							},
						],
						pageTitle: "Routing.Title.VisitPoints",
						rule: "editor",
						permission_id: 5,
						permission_name: "VISIT_POINT",
					},
				},
				{
					path: "/apps/visit-point/visit-point-view/:id",
					name: "app-visit-point-view",
					component: () => import("@/components/visit-point/VisitPointView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/visit-point/visit-point-list"},
							{
								title: "RouterSelection.VisitPoints",
								i18n: "RouterSelection.VisitPoints",
								url: "/apps/visit-point/visit-point-list",
							},
							{
								title: "VisitPoints.ViewPointOfVisit",
								i18n: "VisitPoints.ViewPointOfVisit",
								active: true,
							},
						],
						pageTitle: "VisitPoints.ViewPointOfVisit",
						rule: "editor",
						permission_id: 5,
						permission_name: "VISIT_POINT",
					},
				},
				//VEHICLE
				{
					path: "/apps/vehicle/create/:id?",
					name: "app-vehicle-create",
					component: () => import("@/components/vehicle/create/VehicleCreate.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/vehicle/vehicle-list"},
							{
								title: "Vehicles.Vehicles",
								i18n: "Vehicles.Vehicles",
								url: "/apps/vehicle/vehicle-list",
							},
							{
								title: "Vehicles.CreateVehicle",
								i18n: "Vehicles.CreateVehicle",
								active: true,
							},
						],
						pageTitle: "Vehicles.CreateVehicle",
						rule: "editor",
						permission_id: 5,
						permission_name: "VEHICLE",
					},
				},
				{
					path: "/apps/vehicle/vehicle-edit/:id",
					name: "app-vehicle-edit",
					component: () => import("@/components/vehicle/edit/VehicleEdit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/vehicle/vehicle-list"},
							{
								title: "Vehicles.Vehicles",
								i18n: "Vehicles.Vehicles",
								url: "/apps/vehicle/vehicle-list",
							},
							{
								title: "Vehicles.UpdateVehicle",
								i18n: "Vehicles.UpdateVehicle",
								active: true,
							},
						],
						pageTitle: "Vehicles.UpdateVehicle",
						rule: "editor",
						permission_id: 5,
						permission_name: "VEHICLE",
					},
				},
				{
					path: "/apps/vehicle/vehicle-list",
					name: "app-vehicle-list",
					component: () => import("@/components/vehicle/list/VehicleList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/vehicle/vehicle-list"},
							{
								title: "Vehicles.ListOfVehicles",
								i18n: "Vehicles.ListOfVehicles",
								active: true,
							},
						],
						pageTitle: "Vehicles.Vehicles",
						rule: "editor",
						permission_id: 5,
						permission_name: "VEHICLE",
					},
				},
				{
					path: "/apps/vehicle/vihicle-view/:id",
					name: "app-vehicle-view",
					component: () => import("@/components/vehicle/VehicleView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/vehicle/vehicle-list"},
							{
								title: "Vehicles.Vehicles",
								i18n: "Vehicles.Vehicles",
								url: "/apps/vehicle/vehicle-list",
							},
							{
								title: "Vehicles.ViewVehicles",
								i18n: "Vehicles.ViewVehicles",
								active: true,
							},
						],
						pageTitle: "Vehicles.ViewVehicles",
						rule: "editor",
						permission_id: 5,
						permission_name: "VEHICLE",
					},
				},
				//OPTIMIZATION GROUP
				{
					path: "/apps/optimization-group/optimization-group",
					name: "app-optimization-group-list",
					component: () => import("@/components/optimization-group/list/OptimizationGroupList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/optimization-group/optimization-group"},
							{
								title: "Group.ListOfOptimizationGroups",
								i18n: "Group.ListOfOptimizationGroups",
								active: true,
							},
						],
						pageTitle: "Group.OptimizationGroups",
						rule: "editor",
						permission_id: 5,
						permission_name: "ROUTER",
					},
				},
				//TIME WINDOWS
				{
					path: "/apps/time-window/create",
					name: "app-time-window-create",
					component: () => import("@/components/time-window/create/TimeWindowCreate.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/time-window/time-window-list"},
							{
								title: "TimeWindow.TimeWindows",
								i18n: "TimeWindow.TimeWindows",
								url: "/apps/time-window/time-window-list",
							},
							{
								title: "TimeWindow.CreateTimeWindows",
								i18n: "TimeWindow.CreateTimeWindows",
								active: true,
							},
						],
						pageTitle: "TimeWindow.CreateTimeWindows",
						rule: "editor",
						permission_id: 5,
						permission_name: "TIME_WINDOW",
					},
				},
				{
					path: "/apps/time-window/time-window-edit/:id",
					name: "app-time-window-edit",
					component: () => import("@/components/time-window/edit/TimeWindowEdit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/time-window/time-window-list"},
							{
								title: "TimeWindow.TimeWindows",
								i18n: "TimeWindow.TimeWindows",
								url: "/apps/time-window/time-window-list",
							},
							{
								title: "TimeWindow.UpdateTimeWindow",
								i18n: "TimeWindow.UpdateTimeWindow",
								active: true,
							},
						],
						pageTitle: "TimeWindow.UpdateTimeWindow",
						rule: "editor",
						permission_id: 5,
						permission_name: "TIME_WINDOW",
					},
				},
				{
					path: "/apps/time-window/time-window-list",
					name: "app-time-window-list",
					component: () => import("@/components/time-window/list/TimeWindowList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/time-window/time-window-list"},
							{
								title: "TimeWindow.ListOfTimeWindows",
								i18n: "TimeWindow.ListOfTimeWindows",
								active: true,
							},
						],
						pageTitle: "TimeWindow.TimeWindows",
						rule: "editor",
						permission_id: 5,
						permission_name: "TIME_WINDOW",
					},
				},
				{
					path: "/apps/time-window/time-window-view/:id",
					name: "app-time-window-view",
					component: () => import("@/components/time-window/TimeWindowView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/time-window/time-window-list"},
							{
								title: "TimeWindow.TimeWindows",
								i18n: "TimeWindow.TimeWindows",
								url: "/apps/time-window/time-window-list",
							},
							{
								title: "TimeWindow.ViewTimeWindow",
								i18n: "TimeWindow.ViewTimeWindow",
								active: true,
							},
						],
						pageTitle: "TimeWindow.ViewTimeWindow",
						rule: "editor",
						permission_id: 5,
						permission_name: "TIME_WINDOW",
					},
				},
				{
					path: "/dashboard/preferences/:id?",
					name: "dashboard-preferences",
					component: () => import("@/components/preferences/Preferences.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/dashboard/preferences/"},
							{
								title: "Preferences.ListOfPreferences",
								i18n: "Preferences.ListOfPreferences",
								active: true,
							},
						],
						pageTitle: "Preferences.Preferences",
						i18n: "Preferences.Preferences",
						rule: "editor",
						permission_id: 17,
						permission_name: "ROLE",
						module_name: "ROLE",
					},
				},
				//OPTIMIZER MANAGER
				{
					path: "/apps/optimizer-manager/create/:company_id?",
					name: "app-optimizer-manager-create",
					component: () => import("@/components/optimizer-manager/create/OptimizerManagerCreate.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/optimizer-manager/optimizer-manager-list"},
							{
								title: "OptimizerManager.ManageOptimizers",
								i18n: "OptimizerManager.ManageOptimizers",
								url: "/apps/optimizer-manager/optimizer-manager-list",
							},
							{
								title: "OptimizerManager.CreateConfiguration",
								i18n: "OptimizerManager.CreateConfiguration",
								active: true,
							},
						],
						pageTitle: "OptimizerManager.CreateConfiguration",
						rule: "admin",
						permission_id: 5,
						permission_name: "OPTIMIZER_MANAGER",
					},
				},
				{
					path: "/apps/optimizer-manager/optimizer-manager-edit/:id",
					name: "app-optimizer-manager-edit",
					component: () => import("@/components/optimizer-manager/edit/OptimizerManagerEdit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/optimizer-manager/optimizer-manager-list"},
							{
								title: "OptimizerManager.ManageOptimizers",
								i18n: "OptimizerManager.ManageOptimizers",
								url: "/apps/optimizer-manager/optimizer-manager-list",
							},
							{
								title: "OptimizerManager.UpdateConfiguration",
								i18n: "OptimizerManager.UpdateConfiguration",
								active: true,
							},
						],
						pageTitle: "OptimizerManager.UpdateConfiguration",
						rule: "admin",
						permission_id: 5,
						permission_name: "OPTIMIZER_MANAGER",
					},
				},
				{
					path: "/apps/optimizer-manager/optimizer-manager-list",
					name: "app-optimizer-manager-list",
					component: () => import("@/components/optimizer-manager/list/OptimizerManagerList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/optimizer-manager/optimizer-manager-list"},
							{
								title: "OptimizerManager.ManageOptimizers",
								i18n: "OptimizerManager.ManageOptimizers",
								active: true,
							},
						],
						pageTitle: "OptimizerManager.Optimizers",
						rule: "admin",
						permission_id: 5,
						permission_name: "OPTIMIZER_MANAGER",
					},
				},
				//UPLOAD FILE
				{
					path: "/apps/UploadFiles",
					name: "app-upload-files",
					component: () => import("@/components/upload-file/UploadFile.vue"),
					meta: {
						breadcrumb: [
							{title: "Home", url: "/apps/UploadFileList"},
							{
								title: "UploadFiles.UploadFiles",
								i18n: "UploadFiles.UploadFiles",
								active: true,
							},
						],
						pageTitle: "UploadFiles.UploadFiles",
						pageTitleTwo: "Reports.History",
						rule: "editor",
						permission_id: 10,
						permission_name: "UPLOAD_FILES",
						module_name: "UPLOAD_FILES",
					},
				},
				{
					path: "/apps/UploadFileList",
					name: "app-upload-file-list",
					component: () => import("@/components/upload-file/UploadFileList.vue"),
					meta: {
						breadcrumb: [
							{title: "Home", url: "/apps/UploadFileList"},
							{
								title: "UploadFiles.ListOfUploadedFiles",
								i18n: "UploadFiles.ListOfUploadedFiles",
								active: true,
							},
						],
						pageTitle: "UploadFiles.UploadFiles",
						pageTitleTwo: "Reports.History",
						rule: "editor",
						permission_id: 10,
						permission_name: "UPLOAD_FILES",
						module_name: "UPLOAD_FILES",
					},
				},
				{
					path: "/apps/manual-data/:id",
					name: "app-manual-data",
					component: () => import("@/components/upload-file/ManualDataList.vue"),
					meta: {
						breadcrumb: [
							{title: "Home", url: "/apps/UploadFileList"},
							{
								title: "UploadFiles.UploadFiles",
								i18n: "UploadFiles.UploadFiles",
								url: "/apps/UploadFileList",
							},
							{
								title: "ManualData.ManageError",
								i18n: "ManualData.ManageError",
								active: true,
							},
						],
						pageTitle: "ManualData.ManageError",
						rule: "editor",
						permission_id: 2,
						permission_name: "VISIT_POINT",
						module_name: "VISIT_POINT",
					},
				},
				//RESOURCE
				{
					path: "/apps/resource/resources-list",
					name: "app-resources-list",
					component: () => import("@/components/resource/user-list/ResourceList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/resource/resources-list"},
							{
								title: "ListOfUsers",
								i18n: "ListOfUsers",
								active: true,
							},
						],
						pageTitle: "User",
						rule: "editor",
						permission_id: 5,
						permission_name: "RESOURCES",
					},
				},
				{
					path: "/dashboard/resource-create",
					name: "app-resource-create",
					component: () => import("@/components/resource/create/ResourceCreate.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/resource/resources-list"},
							{
								title: "User",
								i18n: "User",
								url: "/apps/resource/resources-list",
							},
							{
								title: "CreateUser",
								i18n: "CreateUser",
								active: true,
							},
						],
						pageTitle: "CreateUser",
						rule: "editor",
						permission_id: 2,
						permission_name: "RESOURCES",
					},
				},
				{
					path: "/dashboard/resource-edit/:id",
					name: "app-resource-edit",
					component: () => import("@/components/resource/edit/ResourceEdit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/resource/resources-list"},
							{
								title: "User",
								i18n: "User",
								url: "/apps/resource/resources-list",
							},
							{
								title: "UpdateUser",
								i18n: "UpdateUser",
								active: true,
							},
						],
						pageTitle: "UpdateUser",
						rule: "editor",
						permission_id: 2,
						permission_name: "RESOURCES",
					},
				},
				{
					path: "/apps/resource/resource-view/:userId",
					name: "app-resource-view",
					component: () => import("@/components/resource/ResourceView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/resource/resources-list"},
							{
								title: "User",
								i18n: "User",
								url: "/apps/resource/resources-list",
							},
							{
								title: "ViewUser",
								i18n: "ViewUser",
								active: true,
							},
						],
						pageTitle: "ViewUser",
						rule: "editor",
						permission_id: 2,
						permission_name: "RESOURCES",
					},
				},
				//FREQUENCY
				{
					path: "/apps/frequency/frequency-list",
					name: "app-frequency-list",
					component: () => import("@/components/frequency/list/FrequencyList.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/frequency/frequency-list"},
							{
								title: "Frequency.ListOfFrequencies",
								i18n: "Frequency.ListOfFrequencies",
								active: true,
							},
						],
						pageTitle: "Frequency.Frequencies",
						rule: "editor",
						permission_id: 5,
						permission_name: "TIME_WINDOW",
					},
				},
				{
					path: "/apps/frequency/create",
					name: "app-frequency-create",
					component: () => import("@/components/frequency/create/FrequencyCreate.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/frequency/frequency-list"},
							{
								title: "Frequency.Frequencies",
								i18n: "Frequency.Frequencies",
								url: "/apps/frequency/frequency-list",
							},
							{
								title: "Frequency.CreateFrequencies",
								i18n: "Frequency.CreateFrequencies",
								active: true,
							},
						],
						pageTitle: "Frequency.CreateFrequencies",
						rule: "editor",
						permission_id: 5,
						permission_name: "TIME_WINDOW",
					},
				},
				{
					path: "/apps/frequency/frequency-edit/:id",
					name: "app-frequency-edit",
					component: () => import("@/components/frequency/edit/FrequencyEdit.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/frequency/frequency-list"},
							{
								title: "Frequency.Frequencies",
								i18n: "Frequency.Frequencies",
								url: "/apps/frequency/frequency-list",
							},
							{
								title: "Frequency.UpdateFrequency",
								i18n: "Frequency.UpdateFrequency",
								active: true,
							},
						],
						pageTitle: "Frequency.UpdateFrequency",
						rule: "editor",
						permission_id: 5,
						permission_name: "TIME_WINDOW",
					},
				},
				{
					path: "/apps/frequency/frequency-view/:id",
					name: "app-frequency-view",
					component: () => import("@/components/frequency/FrequencyView.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/apps/frequency/frequency-list"},
							{
								title: "Frequency.Frequencies",
								i18n: "Frequency.Frequencies",
								url: "/apps/frequency/frequency-list",
							},
							{
								title: "Frequency.ViewFrequency",
								i18n: "Frequency.ViewFrequency",
								active: true,
							},
						],
						pageTitle: "Frequency.ViewFrequency",
						rule: "editor",
						permission_id: 5,
						permission_name: "TIME_WINDOW",
					},
				},
				//CLUSTERING
				{
					path: "/apps/clustering",
					name: "app-clustering-map",
					component: () => import("@/components/clustering/ClusteringMap.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						permission_id: 5,
						permission_name: "CLUSTERING",
					},
				},
			],
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: "",
			component: () => import("@/layouts/full-page/FullPage.vue"),
			children: [
				// =============================================================================
				// PAGES
				// =============================================================================

				{
					path: "/pages/login/:creds?",
					name: "page-login",
					component: () => import("@/views/pages/login/Login.vue"),
					meta: {
						authRequired: false,
						rule: "editor",
					},
					props: true,
				},
				{
					path: "/pages/register",
					name: "page-register",
					component: () => import("@/views/pages/register/Register.vue"),
					meta: {
						authRequired: false,
						rule: "editor",
					},
				},
				{
					path: "/pages/forgot-password",
					name: "page-forgot-password",
					component: () => import("@/views/pages/ForgotPassword.vue"),
					meta: {
						authRequired: false,
						rule: "editor",
					},
				},
				{
					path: "/pages/reset-password",
					name: "page-reset-password",
					component: () => import("@/views/pages/ResetPassword.vue"),
					meta: {
						authRequired: false,
						rule: "editor",
					},
				},
				{
					path: "/pages/error-404",
					name: "page-error-404",
					component: () => import("@/views/pages/Error404.vue"),
					meta: {
						authRequired: false,
						rule: "editor",
					},
				},
				{
					path: "/pages/error-500",
					name: "page-error-500",
					component: () => import("@/views/pages/Error500.vue"),
					meta: {
						authRequired: false,
						rule: "editor",
					},
				},
				{
					path: "/pages/not-authorized",
					name: "page-not-authorized",
					component: () => import("@/views/pages/NotAuthorized.vue"),
					meta: {
						authRequired: false,
						rule: "editor",
					},
				},
				{
					path: "/pages/maintenance",
					name: "page-maintenance",
					component: () => import("@/views/pages/Maintenance.vue"),
					meta: {
						authRequired: false,
						rule: "editor",
					},
				},
			],
		},
		// Redirect to 404 page, if no match found
		{
			path: "*",
			redirect: "/pages/error-404",
		},
	],
});

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById("loading-bg");
	if (appLoading) {
		appLoading.style.display = "none";
	}
});

router.beforeEach((to, from, next) => {
	const allowedPaths = new Set([
		"/pages/login",
		"/pages/reset-password",
		"/pages/forgot-password",
		"/pages/not-authorized",
	]);
	if (allowedPaths.has(to.fullPath)) {
		next();
		return;
	}
	if (to.meta.authRequired) {
		const userSession = new User();
		userSession
			.getUser()
			.then((val) => {
				const permissionsList = val.serviroutes_permissions;
				store.dispatch("setPermissions", permissionsList);
				const routesNameList = [
					"dashboard-optimization-options",
					"app-optimization",
					"optimization-map",
					"app-reoptimization",
				];
				if (!moduleCompanyConfigCrud.isRegistered) {
					store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
					moduleCompanyConfigCrud.isRegistered = true;
				}
				const shouldShowDropdown = routesNameList.includes(to.name);
				store.commit("moduleCompanyConfigCrud/TOGGLE_ROUTING_TYPE_DROP_DOWN", shouldShowDropdown);
			})
			.catch(() => {
				router.push({path: "/pages/login"});
			});
	}
	next();
});

export default router;
